import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { adaptBrowseFilters } from 'src/redux/products/adapters/browse-data-api/adaptBrowseFilters';
import { adaptBrowseProducts } from 'src/redux/products/adapters/browse-data-api/adaptBrowseProducts';
import { adaptBrowseSortOptions } from 'src/redux/products/adapters/browse-data-api/adaptBrowseSortOptions';

export const healthCheckProducts = createAsyncThunk(
  'products/healthCheck',
  async (_, { getState }) => {
    // Dynamically import json file to prevent it being included on the client. Healthcheck request only happens server side.
    const { healthCheckCategoryResponseBody } = await import(
      'src/services/browse-data-api/fixtures/healthCheckCategoryResponseBody'
    );
    const state = getState() as ReduxApplicationState;
    const { deliveryZone } = state.userConfiguration;

    return {
      filters: adaptBrowseFilters(healthCheckCategoryResponseBody.filters, deliveryZone!),
      products: adaptBrowseProducts(healthCheckCategoryResponseBody),
      sortOptions: adaptBrowseSortOptions(healthCheckCategoryResponseBody.sortingOptions),
    };
  },
);
